import React, {useState} from 'react';

function NewCustomReportModal(props) {
  const [value, setValue] = useState('');
  const [error, setError] = useState('');
  
  return <div className="wrap-custome-add">
    <div className="custome-add">
        <h4>カスタムレポートを保存</h4>
        <input type="text" value={value} onChange={(e) => {
            setValue(e.target.value);
            if(!e.target.value) {
                setError('レポート名を入力してください。');
                return;
            }
            setError('');
        }} placeholder="レポート名"/>
        {error && <div className={'message-error'} style={{fontSize: 14, textAlign: 'left', padding: '10px 0'}}>
            {error}
        </div>}
        <div className={'footer-custom-add'}>
            <button onClick={props.onCloseModal}>キャンセル</button>
            <button onClick={() => {
                if(!value.trim()) {
                    setError('レポート名を入力してください。');
                    return;
                }
                setError('');
                props.onSave(value);
            }}>保存</button>
        </div>
    </div>
  </div>
}

export default NewCustomReportModal;